module.exports = __webpack_public_path__ + "static/app-body-1-5eda6c322def4915a016d00414703881.jpg";